import { render, staticRenderFns } from "./POrder.vue?vue&type=template&id=6a94214b&scoped=true&"
import script from "./POrder.vue?vue&type=script&lang=js&"
export * from "./POrder.vue?vue&type=script&lang=js&"
import style0 from "./POrder.vue?vue&type=style&index=0&id=6a94214b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a94214b",
  null
  
)

export default component.exports